import { render, staticRenderFns } from "./CabinetSidebar.vue?vue&type=template&id=1594fea2&"
import script from "./CabinetSidebar.vue?vue&type=script&lang=js&"
export * from "./CabinetSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CabinetSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports